var _require = require('./publish.escape'),
  escapeHTML = _require.escapeHTML;
function whoTemplate(signers) {
  var rows = (signers || []).map(function (signer) {
    var name = signer.name || signer.email || 'Signer';
    var email = signer.email || '';
    return "\n        <button type=\"button\" class=\"who-signer\" data-who-signer=\"".concat(Number(signer.index), "\">\n          <span class=\"who-signer-name\">").concat(escapeHTML(name), "</span>\n          <span class=\"who-signer-email\">").concat(escapeHTML(email), "</span>\n        </button>\n      ");
  }).join('');
  return "\n    <div class=\"saitosign-who\">\n      <p class=\"title\">Who are you?</p>\n      <div class=\"who-list\" role=\"list\">\n        ".concat(rows, "\n      </div>\n    </div>\n  ");
}
module.exports = whoTemplate;